import { FC } from 'react';
import { MLPVersion } from '../../../types/enums';
import { Data } from '../../DropDown/types/propsType';
import DropDown, { DropDownValidations } from '../../DropDown/DropDown';
import { TooltipPreference } from '../../Tooltip/Tooltip';
import { CountrySelectorProps } from '../types/propsType';
import styles from '../PhoneNumber.module.scss';

const CountrySelector: FC<CountrySelectorProps> = ({
  dropdownDisabled,
  data,
  name,
  placeholder,
  onClearInput,
  dropdownLabel = '',
  dropdownValue,
  dropdownLabelInfo = '',
  dropdownLabelInfoPreference = TooltipPreference.RIGHT,
  configData,
  inputValue = '',
  status = DropDownValidations.DEFAULT,
  ...restProps
}): JSX.Element => (
  <section className={`${styles['country-selector-body']} ${dropdownDisabled ? styles['disabled'] : ''}`}>
    <DropDown
      isCountrySelector
      mlpVersion={MLPVersion.ONE}
      testId="country-dropDown"
      disabled={dropdownDisabled}
      name={name}
      data={data}
      autoComplete={'off'}
      configData={configData}
      value={inputValue}
      dropdownLabel={dropdownLabel}
      selectedCountry={(dropdownValue ? dropdownValue : data?.[0]) as Data}
      labelInfo={dropdownLabelInfo}
      labelInfoPreference={dropdownLabelInfoPreference}
      readOnly={dropdownDisabled}
      placeholder={dropdownValue ? '' : placeholder}
      onClearInput={onClearInput}
      status={status as DropDownValidations}
      {...restProps}
    />
  </section>
);

export default CountrySelector;
